import { HttpRequest } from './http-request';

export class HttpEndpoint {
  constructor(protected _rootPath: string = '') {}

  getRoot(request: HttpRequest) {
    return this._rootPath;
  }
}
